export class ChangedItem {
  constructor(
    public changedAttribute: string,
    public oldValue: string,
    public newValue: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/changed-item.ts